// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

export type SubscriptionStatusValue =
  | "incomplete"
  | "incomplete_expired"
  | "trialing"
  | "active"
  | "past_due"
  | "canceled"
  | "unpaid"
  | "paused"
  | "no_subscription"
  | "unverified";

const ACTIVE_SUBSCRIPTION_STATUSES: readonly string[] = ["active", "trialing"];

export function isSubscriptionActive(status: SubscriptionStatusValue): boolean {
  return ACTIVE_SUBSCRIPTION_STATUSES.includes(status);
}
